<template>
  <b-modal
      id="modal-add-postalCode"
      ref="modal"
      title="Add New Postal Code"
      no-close-on-backdrop
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
      ok-variant="primary primary-btn"
      ok-title="Add"
      cancel-title="Close"
  >
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <b-form-group
          label="Code"
          label-for="code"
          invalid-feedback="Code is required"
          valid-feedback="Look Good"
      >
        <b-form-input
            id="code"
            v-model="code"
            :state="validateCode"
            @keyup="keyupValidationCode"
            required
        ></b-form-input>
      </b-form-group>
      <b-form-group
          label="Province"
          label-for="province"
          invalid-feedback="Choose a Province"
      >
        <v-select
            id="province"
            :options="provinceOptions"
            placeholder="choose..."
            v-model="provinceModel"
            :clearable="true"
            :class="validateProvince"
            @input="provinceSelectedValue($event)"
        >
          <template #search="{attributes, events}">
            <input
                class="vs__search"
                :required="!provinceModel"
                v-bind="attributes"
                v-on="events"
            />
          </template>
        </v-select>
      </b-form-group>
      <b-form-group
          label="Region"
          label-for="region"
          invalid-feedback="Choose a Region"
      >
        <v-select
            id="region"
            :options="regionOptions"
            placeholder="choose..."
            v-model="regionModel"
            :clearable="true"
            :class="validateRegion"
            @input="regionSelectedValue($event)"
        >
          <template #search="{attributes, events}">
            <input
                class="vs__search"
                :required="!regionModel"
                v-bind="attributes"
                v-on="events"
            />
          </template>
        </v-select>
      </b-form-group>
      <b-form-group
          label="Zone"
          label-for="zone"
          invalid-feedback="Choose a Zone"
      >
        <v-select
            id="zone"
            :options="zoneOptions"
            placeholder="choose..."
            v-model="zoneModel"
            :clearable="true"
            :class="validateZone"
            @input="zoneSelectedValue($event)"
        >
          <template #search="{attributes, events}">
            <input
                class="vs__search"
                :required="!zoneModel"
                v-bind="attributes"
                v-on="events"
            />
          </template>
        </v-select>
      </b-form-group>
      <b-form-group
          label="Town"
          label-for="town"
          invalid-feedback="Choose a Town"
      >
        <v-select
            id="town"
            :options="townOptions"
            placeholder="choose..."
            v-model="townModel"
            :clearable="true"
            :class="validateTown"
            @input="townSelectedValue($event)"
        >
          <template #search="{attributes, events}">
            <input
                class="vs__search"
                :required="!townModel"
                v-bind="attributes"
                v-on="events"
            />
          </template>
        </v-select>
      </b-form-group>
    </form>
  </b-modal>
</template>
<script>
import Vue from "vue";
import vSelect from "vue-select";

Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";

export default {
  props: ["zoneOptions", "townOptions", "provinceOptions", "regionOptions"],
  name: "add-region-popup",
  data() {
    return {
      validateCode: null,
      validateProvince: "",
      validateRegion: "",
      validateZone: "",
      validateTown: "",

      provinceModel: "",
      regionModel: "",
      zoneModel: "",
      townModel: "",

      code: "",

      alert: {
        status: false,
        color: "",
        message: ""
      }
    };
  },
  computed: {},
  methods: {
    clearRegionCMB() {
      this.validateRegion = "";
      this.regionModel = "";
    },
    clearZoneCMB() {
      this.validateZone = "";
      this.zoneModel = "";
    },
    clearTownCMB() {
      this.validateTown = "";
      this.townModel = "";
    },

    show() {
      this.$refs.modal.show();
    },
    provinceSelectedValue(event) {
      if (event !== null) {
        this.validateProvince = "";
      } else {
        this.validateProvince = "is-invalid";
      }
      this.clearRegionCMB()
      this.clearZoneCMB()
      this.clearTownCMB()
      this.$emit('changeProvince', event.value)
    },
    regionSelectedValue(event) {
      if (event !== null) {
        this.validateRegion = "";
      } else {
        this.validateRegion = "is-invalid";
      }
      this.clearZoneCMB()
      this.clearTownCMB()
      this.$emit('changeRegion', event.value)
    },
    zoneSelectedValue(event) {
      if (event !== null) {
        this.validateZone = "";
      } else {
        this.validateZone = "is-invalid";
      }
      this.clearTownCMB()
      this.$emit('changeZone', event.value)
    },
    townSelectedValue(event) {
      if (event !== null) {
        this.validateTown = "";
      } else {
        this.validateTown = "is-invalid";
      }
    },
    validateProvinceCMB() {
      if (this.provinceModel !== null) {
        if (this.provinceModel.value == null) {
          this.validateProvince = "is-invalid";
        } else {
          this.validateProvince = "";
        }
      } else {
        this.validateProvince = "is-invalid";
      }
    },
    validateRegionCMB() {
      if (this.regionModel !== null) {
        if (this.regionModel.value == null) {
          this.validateRegion = "is-invalid";
        } else {
          this.validateRegion = "";
        }
      } else {
        this.validateRegion = "is-invalid";
      }
    },
    validateZoneCMB() {
      if (this.zoneModel !== null) {
        if (this.zoneModel.value == null) {
          this.validateZone = "is-invalid";
        } else {
          this.validateZone = "";
        }
      } else {
        this.validateZone = "is-invalid";
      }
    },
    validateTownCMB() {
      if (this.townModel !== null) {
        if (this.townModel.value == null) {
          this.validateTown = "is-invalid";
        } else {
          this.validateTown = "";
        }
      } else {
        this.validateTown = "is-invalid";
      }
    },
    keyupValidationCode() {
      if (this.code !== "") {
        this.validateCode = true;
      } else {
        this.validateCode = false;
      }
    },
    checkFormValidity() {
      const fullFormValidity = this.$refs.form.checkValidity();

      //validate code
      if (this.$refs.form.code.checkValidity()) {
        this.validateCode = true;
      } else {
        this.validateCode = false;
      }

      this.validateProvinceCMB();
      this.validateRegionCMB();
      this.validateZoneCMB();
      this.validateTownCMB()

      return fullFormValidity;
    },
    resetModal() {
      this.validateProvince = "";
      this.validateRegion = "";
      this.validateZone = "";
      this.validateTown = "";
      this.code = "";
      this.validateCode = null;
    },
    async handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      await this.handleSubmit();
    },
    async handleSubmit() {
      // Exit when the form isn't valid
      try {
        if (!this.checkFormValidity()) {
          return null;
        }

        const postalCodePostArray = {
          code: this.code,
          // eslint-disable-next-line @typescript-eslint/camelcase
          town_id: this.townModel.value,
          // eslint-disable-next-line @typescript-eslint/camelcase
          zone_id: this.zoneModel.value
        };

        const response = await this.axios({
          method: "POST",
          url: `${process.env.VUE_APP_API_ADMIN_API_ENDPOINT}/places/postalcodes`,
          headers: {
            Authorization: `Bearer ${this.$store.getters.idToken}`
          },
          data: postalCodePostArray
        });

        this.$nextTick(() => {
          this.$bvModal.hide("modal-add-postalCode");
        });
        this.$emit("success", response.data['success']);
      } catch (errorResponse) {
        this.$emit("error");
        console.error("Error: ", errorResponse);
      }
    }
  }
};
</script>